import React, { useContext } from "react";

// Global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

// to push history once form is submitted
import { useHistory } from "react-router-dom";

// Schema add class state
import { SchemaAddClassStateContext } from "./SchemaAddClassStateContext";

// import helper functions
import { submitAddClassForm } from "./helpers";

const AddClassFormSubmitForm = () => {
  // To consume global state
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);
  const schemaState = useContext(SchemaAddClassStateContext);

  // To use history
  const history = useHistory();

  return (
    <div className="__addClassFormSubmitForm">
      <button
        id="addNewClassSubmitButton"
        onClick={(e) =>
          submitAddClassForm(e, schemaState, state, setState, history)
        }
        className={
          state.theme === "dark"
            ? "__addClassFormSubmit __addClassFormSubmitDark"
            : "__addClassFormSubmit __addClassFormSubmitLight"
        }
        type="submit"
      >
        Add Class
      </button>
      <button
        onClick={() => history.push("/console/Schema")}
        type="button"
        className={
          state.theme === "dark"
            ? "__addClassFormCancel __addClassFormCancelDark"
            : "__addClassFormCancel __addClassFormCancelLight"
        }
      >
        Cancel
      </button>
    </div>
  );
};

export default AddClassFormSubmitForm;
